/**
 * State collection booking overlay.
 * Card already chose city + workshop type → When → styles → cart.
 */
(function (global) {
  var DOW = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  var MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  var productCache = {};
  var productData = {};

  function F() {
    return global.WorkshopCityFlow || {};
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function shopRoot() {
    return (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
  }

  function money(cents) {
    var n = Number(cents) || 0;
    if (n % 100 === 0) return '$' + n / 100;
    if (F().formatMoney) return F().formatMoney(n);
    return '$' + (n / 100).toFixed(2);
  }

  function slotDateKey(slot) {
    return F().slotDateKey ? F().slotDateKey(slot) : String((slot && slot.date_key) || '').slice(0, 10);
  }

  function slotBookable(slot) {
    return F().slotBookable ? F().slotBookable(slot) : true;
  }

  function parseDateKey(dateKey) {
    if (!dateKey) return null;
    var d = new Date(String(dateKey).slice(0, 10) + 'T12:00:00');
    return isNaN(d.getTime()) ? null : d;
  }

  function dateKeyFromDate(d) {
    return (
      d.getFullYear() +
      '-' +
      String(d.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(d.getDate()).padStart(2, '0')
    );
  }

  function slotTimeLabel(slot) {
    if (!slot) return '';
    var label = String(slot.time_label || '').trim();
    if (label) return label;
    var start = slot.schema_start || slot.starts_at || '';
    if (start) {
      var d = new Date(start);
      if (!isNaN(d.getTime())) {
        return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
      }
    }
    return '';
  }

  var longDateCache = {};
  var chipDateCache = {};
  var weekdayCache = {};
  var weekdayLongCache = {};

  function formatLongDate(dateKey) {
    var key = String(dateKey || '');
    if (!key) return '';
    if (longDateCache[key]) return longDateCache[key];
    var d = parseDateKey(key);
    if (!d) return '';
    longDateCache[key] = d.toLocaleDateString('en-US', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
    return longDateCache[key];
  }

  function formatChipDate(dateKey) {
    var key = String(dateKey || '');
    if (!key) return 'Date';
    if (chipDateCache[key]) return chipDateCache[key];
    var d = parseDateKey(key);
    if (!d) return key;
    chipDateCache[key] = d.toLocaleDateString('en-US', { weekday: 'short' }) + ' ' + d.getDate() + ' ' + d.toLocaleDateString('en-US', { month: 'short' });
    return chipDateCache[key];
  }

  function formatFullDate(dateKey) {
    var d = parseDateKey(dateKey);
    if (!d) return '';
    return (
      d.toLocaleDateString('en-US', { weekday: 'long' }) +
      ' ' +
      d.getDate() +
      ' ' +
      d.toLocaleDateString('en-US', { month: 'long' }) +
      ' ' +
      d.getFullYear()
    );
  }

  function formatBagDate(dateKey) {
    return formatFullDate(dateKey);
  }

  function formatWeekdayShort(dateKey) {
    var key = String(dateKey || '');
    if (!key) return '';
    if (weekdayCache[key]) return weekdayCache[key];
    var d = parseDateKey(key);
    if (!d) return '';
    weekdayCache[key] = d.toLocaleDateString('en-US', { weekday: 'short' });
    return weekdayCache[key];
  }

  function formatWeekdayLong(dateKey) {
    var key = String(dateKey || '');
    if (!key) return '';
    if (weekdayLongCache[key]) return weekdayLongCache[key];
    var d = parseDateKey(key);
    if (!d) return '';
    weekdayLongCache[key] = d.toLocaleDateString('en-US', { weekday: 'long' });
    return weekdayLongCache[key];
  }

  function compactTimeLabel(label) {
    return String(label || '').replace(/:00(?=\s|$)/, '');
  }

  function formatCalTimeChip(dateKey, timeLabel) {
    var day = formatWeekdayLong(dateKey);
    var time = compactTimeLabel(timeLabel);
    if (day && time) return day + ' ' + time;
    return time || day || 'Time';
  }

  function formatSummaryWhen(dateKey, timeLabel) {
    var date = formatFullDate(dateKey);
    if (!date) return timeLabel || '';
    return timeLabel ? date + ' · ' + timeLabel : date;
  }

  function formatDateLabel(dateKey) {
    return formatFullDate(dateKey) || 'Pick a date';
  }

  function cdnWidth(src, width) {
    if (!src) return '';
    var url = String(src);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    url = url.replace(/_\d+x\d+(?=\.[a-z]+)(\?|$)/i, '$1');
    if (url.indexOf('cdn.shopify.com') === -1) return url;
    var clean = url.replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, '').replace(/\?&/, '?');
    return clean + (clean.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  function zoomSrc(src) {
    return cdnWidth(src, 1400);
  }

  function thumbSrc(src) {
    return cdnWidth(src, 240);
  }

  function styleCopy(typeKey) {
    if (typeKey === 'mosaic') {
      return {
        title: 'Choose your lamp',
        sub: 'Each seat includes one lamp to take home.',
        kicker: 'Lamps',
        step: 'Lamps',
        next: 'Continue to Mosaic',
        mood: 'A lamp that lights your home',
        unit: 'lamp',
        units: 'lamps',
      };
    }
    if (typeKey === 'ceramic') {
      return {
        title: 'Choose your ceramic',
        sub: 'Each seat includes one ceramic to paint.',
        kicker: 'Ceramics',
        step: 'Ceramics',
        next: 'Continue to Ceramic',
        mood: 'A piece you’ll be proud to keep',
        unit: 'piece',
        units: 'pieces',
      };
    }
    if (typeKey === 'resin') {
      return {
        title: 'Choose your piece',
        sub: 'Each seat includes one resin piece to take home.',
        kicker: 'Resin',
        step: 'Resin',
        next: 'Continue to Resin',
        mood: 'Art you make and take home',
        unit: 'piece',
        units: 'pieces',
      };
    }
    if (typeKey === 'flower') {
      return {
        title: 'Choose your piece',
        sub: 'Each seat includes one floral piece to make.',
        kicker: 'Florals',
        step: 'Florals',
        next: 'Continue to Flower',
        mood: 'Florals you create yourself',
        unit: 'piece',
        units: 'pieces',
      };
    }
    return {
      title: 'Choose your style',
      sub: 'Each seat includes one piece to take home.',
      kicker: 'Style',
      step: 'Style',
      next: 'Continue',
      mood: 'Made by you, kept by you',
      unit: 'piece',
      units: 'pieces',
    };
  }

  function styleOptionIndex(product) {
    var opts = (product && product.options) || [];
    for (var i = 0; i < opts.length; i++) {
      var name = String((opts[i] && opts[i].name) || opts[i] || '').toLowerCase();
      if (name.indexOf('date') >= 0 || name.indexOf('time') >= 0 || name.indexOf('session') >= 0) {
        continue;
      }
      return i;
    }
    return 0;
  }

  function styleLabel(variant, idx) {
    if (idx === 1) return variant.option2 || variant.title;
    if (idx === 2) return variant.option3 || variant.title;
    return variant.option1 || variant.title;
  }

  function featuredSrc(product) {
    var img = product && product.featured_image;
    if (!img) return '';
    if (typeof img === 'string') return img;
    return img.src || '';
  }

  function stylesFromProduct(product) {
    var idx = styleOptionIndex(product);
    var seen = {};
    var out = [];
    ((product && product.variants) || []).forEach(function (v) {
      var label = String(styleLabel(v, idx) || '').trim();
      if (!label || seen[label]) return;
      seen[label] = true;
      var img = v.featured_image && (v.featured_image.src || v.featured_image);
      var price = Number(v.price) || 0;
      var compareAt = Number(v.compare_at_price) || 0;
      out.push({
        id: v.id,
        title: label,
        price: price,
        compareAt: compareAt > price ? compareAt : 0,
        available: v.available !== false,
        image: img || featuredSrc(product),
      });
    });
    return out;
  }

  function fetchProductJs(handle) {
    if (!handle) return Promise.reject(new Error('Missing handle'));
    if (productData[handle]) return Promise.resolve(productData[handle]);
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch(shopRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Product unavailable');
        return res.json();
      })
      .then(function (json) {
        productData[handle] = json;
        return json;
      });
    productCache[handle].catch(function () {
      delete productCache[handle];
    });
    return productCache[handle];
  }

  function createController(collectionRoot) {
    var overlay = collectionRoot.querySelector('[data-swc-book-overlay]');
    if (!overlay) return null;

    var els = {
      sheet: overlay.querySelector('[data-swb-sheet]'),
      crumbs: overlay.querySelectorAll('[data-swb-crumb]'),
      crumbStyle: overlay.querySelector('[data-swb-crumb-style]'),
      back: overlay.querySelector('[data-swb-back]'),
      when: overlay.querySelector('[data-swb-step="when"]'),
      styles: overlay.querySelector('[data-swb-step="styles"]'),
      whenSub: overlay.querySelector('[data-swb-when-sub]'),
      whenEmpty: overlay.querySelector('[data-swb-when-empty]'),
      whenSum: overlay.querySelector('[data-swb-when-sum]'),
      dateDd: overlay.querySelector('[data-swb-date-dd]'),
      dateTrigger: overlay.querySelector('[data-swb-date-trigger]'),
      dateLabel: overlay.querySelector('[data-swb-date-label]'),
      dateMenu: overlay.querySelector('[data-swb-date-menu]'),
      datesPanel: overlay.querySelector('[data-swb-dates-panel]'),
      dates: overlay.querySelector('[data-swb-dates]'),
      timeDd: overlay.querySelector('[data-swb-time-dd]'),
      times: overlay.querySelector('[data-swb-times]'),
      whenError: overlay.querySelector('[data-swb-when-error]'),
      ctaWhen: overlay.querySelector('[data-swb-cta-when]'),
      calMonth: overlay.querySelector('[data-swb-cal-month]'),
      calDow: overlay.querySelector('[data-swb-cal-dow]'),
      calGrid: overlay.querySelector('[data-swb-cal-grid]'),
      calPrev: overlay.querySelector('[data-swb-cal-prev]'),
      calNext: overlay.querySelector('[data-swb-cal-next]'),
      stylesTitle: overlay.querySelector('[data-swb-styles-title]'),
      stylesSub: overlay.querySelector('[data-swb-styles-sub]'),
      stylesList: overlay.querySelector('[data-swb-styles]'),
      stylesEmpty: overlay.querySelector('[data-swb-styles-empty]'),
      inlineStyles: overlay.querySelector('[data-swb-inline-styles]'),
      inlineTitle: overlay.querySelector('[data-swb-inline-title]'),
      stylesInline: overlay.querySelector('[data-swb-styles-inline]'),
      inlineEmpty: overlay.querySelector('[data-swb-inline-empty]'),
      brand: overlay.querySelector('[data-swb-brand]'),
      crumbWhen: overlay.querySelector('[data-swb-crumb="0"]'),
      error: overlay.querySelector('[data-swb-error]'),
      bag: overlay.querySelector('[data-swb-bag]'),
      bagWhen: overlay.querySelector('[data-swb-bag-when]'),
      bagItems: overlay.querySelector('[data-swb-bag-items]'),
      bagSeats: overlay.querySelector('[data-swb-bag-seats]'),
      bagTotal: overlay.querySelector('[data-swb-bag-total]'),
      cta: overlay.querySelector('[data-swb-cta]'),
      steps: overlay.querySelector('[data-swb-steps]'),
      waitlist: overlay.querySelector('[data-swb-step="waitlist"]'),
      wlTitle: overlay.querySelector('[data-swb-wl-title]'),
      wlBody: overlay.querySelector('[data-swb-wl-body]'),
      wlPlace: overlay.querySelector('[data-swb-wl-place]'),
      wlName: overlay.querySelector('[data-swb-wl-name]'),
      wlEmail: overlay.querySelector('[data-swb-wl-email]'),
      wlNotes: overlay.querySelector('[data-swb-wl-notes]'),
      wlError: overlay.querySelector('[data-swb-wl-error]'),
      wlSuccess: overlay.querySelector('[data-swb-wl-success]'),
      zoom: overlay.querySelector('[data-swb-zoom-layer]'),
      zoomImg: overlay.querySelector('[data-swb-zoom-img]'),
      zoomTitle: overlay.querySelector('[data-swb-zoom-title]'),
      zoomMeta: overlay.querySelector('[data-swb-zoom-meta]'),
      zoomPrev: overlay.querySelector('[data-swb-zoom-prev]'),
      zoomNext: overlay.querySelector('[data-swb-zoom-next]'),
      zoomMinus: overlay.querySelector('[data-swb-zoom-minus]'),
      zoomPlus: overlay.querySelector('[data-swb-zoom-plus]'),
      zoomN: overlay.querySelector('[data-swb-zoom-n]'),
    };

    var STEPS = ['when', 'styles', 'waitlist'];
    var lastFocus = null;
    var bound = false;
    var adding = false;
    var advancing = false;
    var wlSubmitting = false;
    var zoomIndex = 0;
    var paint = emptyPaint();

    var session = emptySession();

    function emptyPaint() {
      return { when: false, styles: false, calMonth: '', times: '', dates: '' };
    }

    function emptySession() {
      return {
        step: 0,
        product: null,
        shopify: null,
        styles: [],
        slots: [],
        selectedDate: '',
        preferredDate: '',
        selectedSlot: null,
        viewMonth: new Date(),
        qty: {},
        cartSeats: 0,
        copy: styleCopy('mosaic'),
        wlContext: '',
        wlReturn: false,
        slotsSig: '',
        pendingSlots: false,
      };
    }

    function pickPreferredDate(preferred) {
      var map = daysMap();
      var pref = String(preferred || '').slice(0, 10);
      if (pref && map[pref] && map[pref].bookable) return pref;
      if (pref && map[pref]) return pref;
      return useCalendar() || availableDateKeys().length ? firstDateKey() : '';
    }

    function slotsSignature(slots) {
      return (slots || [])
        .map(function (slot) {
          return [
            slot && slot.gid,
            slotDateKey(slot),
            slot && (slot.display_status || ''),
            slot && (slot.status || ''),
            slot && slot.capacity_remaining,
            slot && (slot.time_label || slot.schema_start || ''),
          ].join(':');
        })
        .join('|');
    }

    function daysMap() {
      var map = {};
      session.slots.forEach(function (slot) {
        var dk = slotDateKey(slot);
        if (!dk) return;
        if (!map[dk]) map[dk] = { bookable: false, any: true };
        if (slotBookable(slot)) map[dk].bookable = true;
      });
      return map;
    }

    function monthHasEvents(y, m) {
      var d = new Date(y, m, 1);
      var prefix = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
      return session.slots.some(function (slot) {
        return slotDateKey(slot).indexOf(prefix) === 0;
      });
    }

    function shiftMonth(dir) {
      var next = new Date(session.viewMonth.getFullYear(), session.viewMonth.getMonth() + dir, 1);
      if (!monthHasEvents(next.getFullYear(), next.getMonth())) return;
      session.viewMonth = next;
      renderCalendar();
    }

    function availableDateKeys() {
      var keys = [];
      var seen = {};
      session.slots.forEach(function (slot) {
        var dk = slotDateKey(slot);
        if (!dk || seen[dk]) return;
        seen[dk] = true;
        keys.push(dk);
      });
      keys.sort();
      return keys;
    }

    function useCalendar() {
      return availableDateKeys().length > 8;
    }

    function isCompact() {
      return session.slots.length > 0 && !useCalendar();
    }

    function slotsOnDate(dateKey) {
      var seen = {};
      return session.slots
        .filter(function (slot) {
          if (slotDateKey(slot) !== dateKey) return false;
          var label = slotTimeLabel(slot) || String(slot.gid || '');
          if (seen[label]) return false;
          seen[label] = true;
          return true;
        })
        .sort(function (a, b) {
          return String(a.schema_start || slotTimeLabel(a)).localeCompare(
            String(b.schema_start || slotTimeLabel(b))
          );
        });
    }

    function sortSlotsByWhen(slots) {
      return (slots || []).slice().sort(function (a, b) {
        return (slotDateKey(a) + String(a.schema_start || slotTimeLabel(a))).localeCompare(
          slotDateKey(b) + String(b.schema_start || slotTimeLabel(b))
        );
      });
    }

    function firstDateKey() {
      var bookable = sortSlotsByWhen(session.slots.filter(slotBookable));
      if (bookable[0]) return slotDateKey(bookable[0]);
      var first = sortSlotsByWhen(session.slots)[0];
      return first ? slotDateKey(first) : '';
    }

    function hasBookable() {
      return session.slots.some(slotBookable);
    }

    function dateHasBookable(dateKey) {
      if (!dateKey) return false;
      return session.slots.some(function (slot) {
        return slotDateKey(slot) === dateKey && slotBookable(slot);
      });
    }

    function totalQty() {
      var n = 0;
      Object.keys(session.qty).forEach(function (id) {
        n += session.qty[id] || 0;
      });
      return n;
    }

    function selectedStyles() {
      return session.styles.filter(function (style) {
        return (session.qty[style.id] || 0) > 0;
      });
    }

    function lineTotal() {
      var sum = 0;
      session.styles.forEach(function (style) {
        sum += (session.qty[style.id] || 0) * style.price;
      });
      return sum;
    }

    function compareLineTotal() {
      var live = 0;
      var was = 0;
      var sale = false;
      session.styles.forEach(function (style) {
        var q = session.qty[style.id] || 0;
        if (!q) return;
        live += q * style.price;
        if (style.compareAt > style.price) {
          sale = true;
          was += q * style.compareAt;
        } else {
          was += q * style.price;
        }
      });
      return sale && was > live ? was : 0;
    }

    function priceHtml(style, suffix) {
      var now = '<span class="swb__price-now">' + escapeHtml(money(style.price)) + '</span>';
      var html =
        style.compareAt > style.price
          ? '<s class="swb__price-was">' + escapeHtml(money(style.compareAt)) + '</s> ' + now
          : now;
      if (suffix) html += '<span class="swb__price-seat"> · ' + escapeHtml(suffix) + '</span>';
      return html;
    }

    function maxBookable() {
      var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
      var cfg = CFG && CFG.readBootstrap ? CFG.readBootstrap(collectionRoot) : {};
      var enforce = (cfg && cfg.enforce) || {};
      var maxPer = enforce.max_qty_per_order != null ? Number(enforce.max_qty_per_order) : 20;
      if (!Number.isFinite(maxPer) || maxPer <= 0) maxPer = 20;
      var capMax = 20;
      var slot = session.selectedSlot;
      if (slot && slot.capacity_remaining != null && slot.capacity_remaining !== '') {
        var cap = Number(slot.capacity_remaining);
        if (!isNaN(cap) && cap >= 0) capMax = Math.floor(cap);
      }
      var room = capMax - (session.cartSeats || 0);
      if (room < 0) room = 0;
      return Math.min(maxPer, room);
    }

    function isDesktop() {
      return window.matchMedia && window.matchMedia('(min-width: 900px)').matches;
    }

    function cityName() {
      return String((session.product && session.product.cityName) || '').trim();
    }

    function calendarOpen() {
      return useCalendar();
    }

    function setMenu(dd, menu, trigger, open) {
      if (dd) dd.classList.toggle('is-open', !!open);
      if (menu) menu.hidden = !open;
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeMenus() {
      setMenu(els.dateDd, els.dateMenu, els.dateTrigger, calendarOpen());
    }

    function showWhenError(msg) {
      if (els.whenError) {
        els.whenError.hidden = !msg;
        els.whenError.textContent = msg || '';
      }
      if (els.dateDd) els.dateDd.classList.toggle('is-invalid', !!msg && !session.selectedDate);
      if (els.timeDd) els.timeDd.classList.toggle('is-invalid', !!msg && !!session.selectedDate && !session.selectedSlot);
      if (els.inlineStyles) {
        els.inlineStyles.classList.toggle(
          'is-invalid',
          !!msg && isCompact() && !!session.selectedSlot && totalQty() < 1
        );
      }
    }

    function shakeMissing() {
      var target = null;
      if (!session.selectedDate) target = els.dateDd;
      else if (!session.selectedSlot || !dateHasBookable(session.selectedDate)) target = els.timeDd;
      else if (totalQty() < 1) target = isCompact() ? els.inlineStyles : els.stylesList;
      if (!target) return;
      target.classList.remove('is-shake');
      void target.offsetWidth;
      target.classList.add('is-shake');
      target.addEventListener(
        'animationend',
        function () {
          target.classList.remove('is-shake');
        },
        { once: true }
      );
    }

    function whenWarning() {
      if (!session.slots.length) return 'No upcoming sessions for this workshop.';
      if (!hasBookable()) return 'This workshop is sold out.';
      if (!session.selectedDate) return 'Please pick a date.';
      if (!dateHasBookable(session.selectedDate)) return 'This date is sold out.';
      if (!session.selectedSlot) return 'Please pick a time.';
      if (!slotBookable(session.selectedSlot)) return 'That time is no longer available.';
      if (isCompact() && session.step === 0 && totalQty() < 1) {
        return 'Please choose at least one ' + (session.copy.unit || 'style') + '.';
      }
      return '';
    }

    function setOverlayAttrs() {
      var p = session.product || {};
      overlay.setAttribute('data-city-name', p.cityName || '');
      overlay.setAttribute('data-venue-name', p.venueName || '');
      overlay.setAttribute('data-venue-address', p.venueAddress || '');
      overlay.setAttribute('data-state-name', p.productState || collectionRoot.getAttribute('data-state-name') || '');
      overlay.setAttribute('data-address-country', p.addressCountry || 'US');
      overlay.setAttribute('data-product-handle', p.handle || '');
      overlay.setAttribute('data-product-title', p.title || '');
      overlay.setAttribute('data-workshop-type', p.workshopType || 'mosaic');
    }

    function buildEventProperties(slot) {
      var p = session.product || {};
      var cityName = String(p.cityName || '').trim();
      var venueName = String(p.venueName || '').trim();
      var displayDatetime = String(slot.display_label || slot.time_label || '').trim();
      var bookingParts = [];
      if (cityName) bookingParts.push(cityName);
      if (venueName && venueName !== cityName) bookingParts.push(venueName);
      var bookingDetails = bookingParts.join(' — ');
      if (displayDatetime) {
        bookingDetails = bookingDetails ? bookingDetails + ' · ' + displayDatetime : displayDatetime;
      }
      var props = {
        _workshop: 'true',
        _is_workshop: '1',
        _workshop_city: '1',
        _product_handle: String(p.handle || ''),
        _event_metaobject_gid: String(slot.gid || ''),
        _slot_handle: String(slot.handle || ''),
      };
      if (bookingDetails) props['Booking Details'] = bookingDetails;
      if (cityName) props._display_city = cityName;
      if (venueName) props._display_venue = venueName;
      if (displayDatetime) props._display_datetime = displayDatetime;
      if (slot.schema_start) props._schema_start = String(slot.schema_start);
      if (slot.schema_end) props._schema_end = String(slot.schema_end);
      if (slot.date_key) props._date_key = String(slot.date_key);
      if (slot.time_label) props._time_label = String(slot.time_label);
      if (slot.display_label) props._session_label = String(slot.display_label);
      var flow = F();
      if (flow.appendVenueContactProperties) flow.appendVenueContactProperties(overlay, props);
      if (flow.appendCartValidationProperties) flow.appendCartValidationProperties(slot, props);
      return props;
    }

    function refreshCartSeats() {
      var flow = F();
      var gid = session.selectedSlot && session.selectedSlot.gid;
      if (!gid || !flow.fetchCartSeatsForEvent) {
        session.cartSeats = 0;
        return Promise.resolve(0);
      }
      return flow.fetchCartSeatsForEvent(gid).then(function (n) {
        session.cartSeats = n || 0;
        return session.cartSeats;
      });
    }

    function resolveLiveUrl() {
      var API = global.WorkshopCityEvents || {};
      var catalog =
        collectionRoot.getAttribute('data-live-state-api-url') ||
        collectionRoot.getAttribute('data-state-api-url') ||
        collectionRoot.getAttribute('data-events-api-url') ||
        '';
      if (API.resolveLiveStateApiUrl) return API.resolveLiveStateApiUrl(collectionRoot, catalog);
      return catalog;
    }

    function ensureFreshSlot(slot) {
      var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
      var gates = CFG && CFG.readBootstrap ? (CFG.readBootstrap(collectionRoot).gates || {}) : {};
      if (gates.live_fetch_before_add === false) return Promise.resolve(slot);
      var API = global.WorkshopCityEvents || {};
      if (!API.fetchLiveState || !slot || !slot.gid) return Promise.resolve(slot);
      return API.fetchLiveState([slot.gid], { url: resolveLiveUrl(), root: collectionRoot })
        .then(function (r) {
          var merged = API.mergeSlotWithLive
            ? API.mergeSlotWithLive(slot, (r && r.states) || {}, r && r.as_of)
            : slot;
          if (merged) session.selectedSlot = merged;
          return merged;
        })
        .catch(function () {
          return slot;
        });
    }

    function validateCapacity(slot, qty) {
      var API = global.WorkshopCityEvents || {};
      var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
      var gated =
        CFG && typeof CFG.validateGateEnabled === 'function' && CFG.validateGateEnabled(collectionRoot, 'add_to_cart');
      if (!API.fetchCapacityValidate || !slot || !slot.gid) {
        if (gated) {
          return Promise.resolve({
            blocked: true,
            message: 'We could not verify workshop capacity right now. Please try again.',
          });
        }
        return Promise.resolve({ blocked: false, slot: slot });
      }
      if (!gated) return Promise.resolve({ blocked: false, slot: slot });
      return API.fetchCapacityValidate(collectionRoot, {
        event_id: slot.gid,
        requested_total_qty: (session.cartSeats || 0) + (qty || 0),
        intent: 'add_to_cart',
      }).then(function (result) {
        if (!result) {
          if (CFG && CFG.validateFailModeOpen && CFG.validateFailModeOpen(collectionRoot)) {
            return { blocked: false, slot: slot };
          }
          return {
            blocked: true,
            message: 'We could not verify workshop capacity right now. Please try again.',
          };
        }
        if (result.capacity_remaining != null && result.capacity_remaining !== '') {
          slot.capacity_remaining = result.capacity_remaining;
        }
        if (result.display_status != null && result.display_status !== '') {
          slot.display_status = result.display_status;
        }
        if (result.status != null && result.status !== '') {
          slot.status = result.status;
        }
        if (result.allowed === false) {
          return {
            blocked: true,
            slot: slot,
            message:
              result.message ||
              (Number(result.capacity_remaining) > 0
                ? 'Only ' + result.capacity_remaining + ' seat(s) remain for this session.'
                : 'This session is sold out.'),
          };
        }
        return { blocked: false, slot: slot };
      });
    }

    function showError(msg) {
      if (!els.error) return;
      els.error.hidden = !msg;
      els.error.textContent = msg || '';
    }

    function setStep(index) {
      if (isCompact() && index === 1) index = 0;
      session.step = index;
      STEPS.forEach(function (id, i) {
        var el = overlay.querySelector('[data-swb-step="' + id + '"]');
        if (el) el.hidden = i !== index;
      });
      var compact = isCompact();
      var onWaitlist = index === 2;
      overlay.classList.toggle('is-compact', compact && !onWaitlist);
      overlay.classList.toggle('is-when', index === 0);
      overlay.classList.toggle('is-waitlist', onWaitlist);
      if (els.steps) els.steps.hidden = onWaitlist;
      els.crumbs.forEach(function (crumb) {
        var i = Number(crumb.getAttribute('data-swb-crumb'));
        if (onWaitlist) {
          crumb.hidden = true;
        } else if (compact) {
          crumb.hidden = i !== 0;
          crumb.classList.toggle('is-on', i === 0);
          crumb.classList.toggle('is-done', false);
        } else {
          crumb.hidden = false;
          crumb.classList.toggle('is-on', i === index);
          crumb.classList.toggle('is-done', i < index);
        }
      });
      if (els.brand) els.brand.textContent = session.copy.mood || 'Made by you, kept by you';
      if (els.crumbWhen) els.crumbWhen.textContent = compact ? 'Book' : 'Date';
      if (els.crumbStyle) els.crumbStyle.textContent = session.copy.step || 'Style';
      if (els.back) els.back.hidden = index === 0 || (onWaitlist && !session.wlReturn);
      closeMenus();
      showError('');
      showWhenError('');
      if (index === 0) {
        if (paint.when) {
          if (els.inlineStyles) els.inlineStyles.hidden = !compact;
        } else {
          renderWhen();
        }
      }
      if (index === 1) {
        if (els.stylesList && els.stylesList.querySelector('[data-swb-style]')) syncStyleRows();
        else renderStyles();
      }
      if (onWaitlist) renderWaitlist();
      updateCta();
      var scroller = overlay.querySelector('.swb__scroll');
      if (scroller) scroller.scrollTop = 0;
    }

    function markSelected(root, attr, value) {
      if (!root) return;
      var nodes = root.querySelectorAll('[' + attr + ']');
      var i;
      for (i = 0; i < nodes.length; i++) {
        nodes[i].classList.toggle('is-on', nodes[i].getAttribute(attr) === value);
      }
    }

    function renderCalendar(force) {
      var y = session.viewMonth.getFullYear();
      var m = session.viewMonth.getMonth();
      var monthKey = y + '-' + m;
      if (els.calMonth) els.calMonth.textContent = MONTHS[m] + ' ' + y;
      if (els.calPrev) els.calPrev.disabled = !monthHasEvents(y, m - 1);
      if (els.calNext) els.calNext.disabled = !monthHasEvents(y, m + 1);
      if (!els.calGrid) return;
      if (!force && paint.calMonth === monthKey && els.calGrid.querySelector('[data-swb-day]')) {
        markSelected(els.calGrid, 'data-swb-day', session.selectedDate);
        return;
      }
      paint.calMonth = monthKey;
      if (els.calDow && !els.calDow.childElementCount) {
        els.calDow.innerHTML = DOW.map(function (d) {
          return '<span>' + d + '</span>';
        }).join('');
      }
      var map = daysMap();
      var first = new Date(y, m, 1);
      var startPad = first.getDay();
      var daysInMonth = new Date(y, m + 1, 0).getDate();
      var html = '';
      var i;
      for (i = 0; i < startPad; i++) {
        html += '<span class="swb__day swb__day--empty"></span>';
      }
      for (var d = 1; d <= daysInMonth; d++) {
        var key = y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
        var info = map[key];
        var cls = 'swb__day';
        if (!info) cls += ' swb__day--muted';
        else {
          cls += ' swb__day--has';
          if (!info.bookable) cls += ' swb__day--sold';
        }
        if (session.selectedDate === key) cls += ' is-on';
        html +=
          '<button type="button" class="' +
          cls +
          '" data-swb-day="' +
          key +
          '"' +
          (info ? '' : ' disabled') +
          '>' +
          d +
          '</button>';
      }
      els.calGrid.innerHTML = html;
    }

    function updateWhenSum() {
      if (!els.whenSum) return;
      var picked = !!(session.selectedSlot && session.selectedDate);
      els.whenSum.textContent = picked
        ? formatSummaryWhen(session.selectedDate, slotTimeLabel(session.selectedSlot))
        : session.selectedDate
          ? 'Pick a time to continue.'
          : '';
      els.whenSum.classList.toggle('is-set', picked);
    }

    function selectedTimeValue() {
      if (!session.selectedSlot) return '';
      return String(session.selectedSlot.gid || slotTimeLabel(session.selectedSlot));
    }

    function timesDateKey() {
      return session.selectedDate || availableDateKeys()[0] || firstDateKey();
    }

    function renderTimes(force) {
      if (els.dateLabel) {
        els.dateLabel.textContent = session.selectedDate ? formatDateLabel(session.selectedDate) : 'Pick a date';
      }
      if (!els.times) return;
      var dateKey = timesDateKey();
      if (!dateKey) {
        paint.times = '';
        els.times.innerHTML = '<p class="swb__times-empty">No times available.</p>';
        updateWhenSum();
        return;
      }
      if (!force && paint.times === dateKey && els.times.querySelector('[data-swb-time]')) {
        markSelected(els.times, 'data-swb-time', selectedTimeValue());
        updateWhenSum();
        return;
      }
      var daySlots = slotsOnDate(dateKey);
      if (!daySlots.length) {
        paint.times = dateKey;
        els.times.innerHTML = '<p class="swb__times-empty">No times on this day.</p>';
        updateWhenSum();
        return;
      }
      paint.times = dateKey;
      var selected = selectedTimeValue();
      var cal = useCalendar();
      els.times.innerHTML = daySlots
        .map(function (slot) {
          var label = slotTimeLabel(slot);
          var gid = String(slot.gid || label);
          var bookable = slotBookable(slot);
          var body =
            cal && isDesktop()
              ? escapeHtml(formatCalTimeChip(dateKey, label))
              : escapeHtml(compactTimeLabel(label || 'Time'));
          if (!bookable) body += ' · join waitlist';
          return (
            '<button type="button" class="swb__time' +
            (gid === selected ? ' is-on' : '') +
            (bookable ? '' : ' is-soldout') +
            '" data-swb-time="' +
            escapeHtml(gid) +
            '">' +
            body +
            '</button>'
          );
        })
        .join('');
      updateWhenSum();
    }

    function renderDateList(force) {
      if (!els.dates) return;
      var keys = availableDateKeys();
      var sig = keys.join('|');
      if (!force && paint.dates === sig && els.dates.querySelector('[data-swb-day]')) {
        markSelected(els.dates, 'data-swb-day', session.selectedDate);
        return;
      }
      paint.dates = sig;
      var map = daysMap();
      els.dates.innerHTML = keys
        .map(function (key) {
          var info = map[key];
          var bookable = !!(info && info.bookable);
          return (
            '<button type="button" class="swb__date' +
            (session.selectedDate === key ? ' is-on' : '') +
            (bookable ? '' : ' is-soldout') +
            '" data-swb-day="' +
            escapeHtml(key) +
            '">' +
            escapeHtml(formatFullDate(key)) +
            (bookable ? '' : ' · sold out') +
            '</button>'
          );
        })
        .join('');
    }

    function renderWhen() {
      var city = session.product && session.product.cityName ? session.product.cityName : '';
      var has = session.slots.length > 0;
      var soldOut = has && !hasBookable();
      if (els.whenSub) {
        els.whenSub.textContent = soldOut ? (city ? city + ' · Sold out' : 'Sold out') : city;
      }
      var cal = has && useCalendar();
      var compact = isCompact();
      overlay.setAttribute('data-date-mode', !has ? 'empty' : cal ? 'cal' : 'list');
      overlay.classList.toggle('is-compact', compact);
      overlay.classList.toggle('is-soldout', soldOut);
      if (els.whenEmpty) {
        if (session.pendingSlots) {
          els.whenEmpty.hidden = false;
          els.whenEmpty.textContent = 'Loading sessions…';
        } else {
          els.whenEmpty.hidden = has;
          els.whenEmpty.textContent = 'No upcoming sessions for this workshop.';
        }
      }
      if (els.dateDd) els.dateDd.hidden = !has;
      if (els.timeDd) els.timeDd.hidden = !has;
      if (els.inlineStyles) els.inlineStyles.hidden = !compact;
      if (!has) {
        if (els.dates) els.dates.innerHTML = '';
        if (els.times) els.times.innerHTML = '';
        if (els.calGrid) els.calGrid.innerHTML = '';
        return;
      }
      if (cal) {
        if (els.dates) els.dates.innerHTML = '';
        renderCalendar();
        setMenu(els.dateDd, els.dateMenu, els.dateTrigger, true);
      } else {
        renderDateList();
        setMenu(els.dateDd, els.dateMenu, els.dateTrigger, false);
      }
      renderTimes();
      if (compact) renderStyles();
      paint.when = true;
    }

    function stylesTarget() {
      if (isCompact() && els.stylesInline) {
        return {
          list: els.stylesInline,
          empty: els.inlineEmpty,
          title: els.inlineTitle,
        };
      }
      return {
        list: els.stylesList,
        empty: els.stylesEmpty,
        title: els.stylesTitle,
      };
    }

    function applyShopify(shopify) {
      session.shopify = shopify;
      session.styles = stylesFromProduct(shopify);
    }

    function syncStyleRows() {
      var target = stylesTarget();
      if (!target.list) return false;
      var rows = target.list.querySelectorAll('[data-swb-style]');
      if (!rows.length || !session.styles.length) return false;
      var max = maxBookable();
      var used = totalQty();
      var i;
      for (i = 0; i < rows.length; i++) {
        var id = rows[i].getAttribute('data-swb-style');
        var q = session.qty[id] || 0;
        var style = null;
        var s;
        for (s = 0; s < session.styles.length; s++) {
          if (String(session.styles[s].id) === String(id)) {
            style = session.styles[s];
            break;
          }
        }
        rows[i].classList.toggle('is-on', q > 0);
        rows[i].classList.toggle('is-unavailable', !!(style && !style.available));
        var n = rows[i].querySelector('.swb__stepper-n');
        if (n) n.textContent = q;
        var minus = rows[i].querySelector('[data-swb-qty="-1"]');
        var plus = rows[i].querySelector('[data-swb-qty="1"]');
        if (minus) minus.disabled = q <= 0;
        if (plus) plus.disabled = used >= max || (style && !style.available);
      }
      return true;
    }

    function renderStyles() {
      var copy = session.copy;
      var target = stylesTarget();
      if (els.stylesTitle) els.stylesTitle.textContent = copy.title;
      if (els.inlineTitle) els.inlineTitle.textContent = copy.title;
      if (els.stylesSub) els.stylesSub.textContent = copy.sub;
      if (target.empty) target.empty.hidden = true;

      if (!session.shopify) {
        if (target.list && !target.list.querySelector('[data-swb-style]')) {
          target.list.innerHTML =
            '<span class="swb__skel"></span><span class="swb__skel"></span><span class="swb__skel"></span>';
        }
        if (session.product && session.product.handle) {
          fetchProductJs(session.product.handle)
            .then(function (shopify) {
              applyShopify(shopify);
              if (session.step === 1 || (isCompact() && session.step === 0)) renderStyles();
              updateCta();
            })
            .catch(function () {
              if (target.empty) {
                target.empty.hidden = false;
                target.empty.textContent = 'Could not load workshop options. Please try again.';
              }
              if (target.list) target.list.innerHTML = '';
            });
        }
        return;
      }

      if (!session.styles.length) {
        if (target.list) target.list.innerHTML = '';
        if (target.empty) {
          target.empty.hidden = false;
          target.empty.textContent = 'No styles are available for this workshop.';
        }
        return;
      }

      if (syncStyleRows() && target.list.querySelectorAll('[data-swb-style]').length === session.styles.length) {
        paint.styles = true;
        return;
      }

      var max = maxBookable();
      var used = totalQty();
      if (!target.list) return;
      target.list.innerHTML = session.styles
        .map(function (style, idx) {
          var q = session.qty[style.id] || 0;
          var img = style.image
            ? '<button type="button" class="swb__style-media" data-swb-zoom="' +
              style.id +
              '" aria-label="View larger photo of ' +
              escapeHtml(style.title) +
              '"><img class="swb__style-img" src="' +
              escapeHtml(thumbSrc(style.image)) +
              '" alt="" width="68" height="68" decoding="async" loading="' +
              (idx < 4 ? 'eager' : 'lazy') +
              '"></button>'
            : '<span class="swb__style-ph" aria-hidden="true"></span>';
          return (
            '<div class="swb__style' +
            (q ? ' is-on' : '') +
            (style.available ? '' : ' is-unavailable') +
            '" data-swb-style="' +
            style.id +
            '">' +
            img +
            '<div class="swb__style-copy"><p class="swb__style-name">' +
            escapeHtml(style.title) +
            '</p><p class="swb__style-meta">' +
            priceHtml(style, 'one seat') +
            '</p></div>' +
            '<div class="swb__stepper">' +
            '<button type="button" class="swb__stepper-btn" data-swb-qty="-1" data-id="' +
            style.id +
            '"' +
            (q <= 0 ? ' disabled' : '') +
            ' aria-label="Decrease">−</button>' +
            '<span class="swb__stepper-n">' +
            q +
            '</span>' +
            '<button type="button" class="swb__stepper-btn" data-swb-qty="1" data-id="' +
            style.id +
            '"' +
            (used >= max || !style.available ? ' disabled' : '') +
            ' aria-label="Increase">+</button>' +
            '</div></div>'
          );
        })
        .join('');
      paint.styles = true;
    }

    function renderBag() {
      if (!els.bag) return;
      var qty = totalQty();
      var show = qty > 0 && session.step !== 2 && (session.step === 1 || isCompact());
      els.bag.hidden = !show;
      overlay.classList.toggle('is-ready', show);
      var dateText = session.selectedDate ? formatBagDate(session.selectedDate) : '';
      var timeText = compactTimeLabel(slotTimeLabel(session.selectedSlot));
      var when = [dateText, timeText].filter(Boolean).join(' · ');
      var onStyles = session.step === 1 || isCompact();
      if (els.bagWhen) {
        els.bagWhen.textContent = when;
        els.bagWhen.hidden = !onStyles || !when;
      }
      if (!show) return;
      if (els.bagItems) {
        var faces = [];
        selectedStyles().forEach(function (style) {
          var n = session.qty[style.id] || 0;
          var i;
          for (i = 0; i < n; i++) faces.push(style);
        });
        var max = isDesktop() ? 8 : 5;
        var html = faces
          .slice(0, max)
          .map(function (style, idx) {
            var media = style.image
              ? '<img src="' +
                escapeHtml(thumbSrc(style.image)) +
                '" alt="" width="52" height="52" decoding="async">'
              : '<span class="swb__face-ph" aria-hidden="true"></span>';
            return (
              '<span class="swb__face" style="--i:' +
              idx +
              '" title="' +
              escapeHtml(style.title) +
              '">' +
              media +
              '</span>'
            );
          })
          .join('');
        if (faces.length > max) {
          html +=
            '<span class="swb__face swb__face--more" style="--i:' +
            max +
            '">+' +
            (faces.length - max) +
            '</span>';
        }
        els.bagItems.innerHTML = html;
      }
      if (els.bagSeats) {
        els.bagSeats.textContent = qty + ' seat' + (qty === 1 ? '' : 's');
      }
      if (els.bagTotal) {
        var live = lineTotal();
        var was = compareLineTotal();
        els.bagTotal.innerHTML =
          was > live
            ? '<s class="swb__price-was">' +
              escapeHtml(money(was)) +
              '</s> ' +
              escapeHtml(money(live))
            : escapeHtml(money(live));
      }
    }

    function syncCta(label, disabled) {
      [els.cta, els.ctaWhen].forEach(function (btn) {
        if (!btn) return;
        btn.textContent = label;
        btn.disabled = !!disabled;
      });
    }

    function waitlistLabel() {
      return collectionRoot.getAttribute('data-waitlist-label') || 'Join waitlist';
    }

    function waitlistUrl() {
      return (
        collectionRoot.getAttribute('data-waitlist-url') ||
        'https://amc-ew.aogen.com.au/api/public/waitlist'
      );
    }

    function showWlMessage(err, ok) {
      if (els.wlError) {
        els.wlError.hidden = !err;
        els.wlError.textContent = err || '';
      }
      if (els.wlSuccess) {
        els.wlSuccess.hidden = !ok;
        if (ok) els.wlSuccess.textContent = ok;
      }
    }

    function renderWaitlist() {
      var sold = session.wlContext === 'sold_out';
      if (els.wlTitle) {
        els.wlTitle.textContent = sold
          ? collectionRoot.getAttribute('data-waitlist-sold-title') || 'This session is sold out'
          : collectionRoot.getAttribute('data-waitlist-title') || 'No workshops scheduled yet';
      }
      if (els.wlBody) {
        els.wlBody.textContent = sold
          ? collectionRoot.getAttribute('data-waitlist-sold-body') ||
            'Join the waitlist and we will notify you if a seat opens.'
          : collectionRoot.getAttribute('data-waitlist-body') ||
            'Join the waitlist and we will notify you when new sessions are added.';
      }
      if (els.wlPlace) {
        var place = cityName();
        if (sold && session.selectedDate) {
          place = [place, formatFullDate(session.selectedDate), compactTimeLabel(slotTimeLabel(session.selectedSlot))]
            .filter(Boolean)
            .join(' · ');
        } else if (sold && place) {
          place += ' · Sold out';
        }
        els.wlPlace.textContent = place;
      }
    }

    function showWaitlist(context, canReturn) {
      session.wlContext = context || (session.slots.length ? 'sold_out' : 'no_events');
      session.wlReturn = !!canReturn;
      setStep(2);
    }

    function submitWaitlist() {
      if (wlSubmitting) return;
      var nameV = els.wlName ? String(els.wlName.value || '').trim() : '';
      var emailV = els.wlEmail ? String(els.wlEmail.value || '').trim() : '';
      if (!nameV) {
        showWlMessage('Please enter your name.', '');
        return;
      }
      if (!emailV || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailV)) {
        showWlMessage('Please enter a valid email.', '');
        return;
      }
      var notes = els.wlNotes ? String(els.wlNotes.value || '').trim() : '';
      if (session.wlContext === 'sold_out' && session.selectedDate) {
        notes =
          (notes ? notes + ' | ' : '') +
          'Sold out slot date: ' +
          session.selectedDate +
          (session.selectedSlot ? ' · ' + slotTimeLabel(session.selectedSlot) : '');
      }
      var flow = F();
      var handle = (session.product && session.product.handle) || '';
      var workshopType =
        (session.product && session.product.workshopType) ||
        (flow.resolveWorkshopType ? flow.resolveWorkshopType(overlay, { productHandle: handle }) : 'mosaic');
      var venueId = flow.resolveWaitlistVenueId
        ? flow.resolveWaitlistVenueId(overlay, { productHandle: handle })
        : handle;
      var payload = {
        email: emailV,
        name: nameV,
        venue_id: venueId,
        venue_name: cityName() || handle,
        shop_domain: global.Shopify && global.Shopify.shop ? String(global.Shopify.shop) : '',
        workshop_type: workshopType,
        preferred_date: session.selectedDate || 'not_sure',
        notes: notes,
        source: flow.normalizeWaitlistSource
          ? flow.normalizeWaitlistSource(session.wlContext || 'no_events')
          : session.wlContext || 'no_events',
      };
      wlSubmitting = true;
      showWlMessage('', '');
      updateCta();
      var submit = flow.submitWaitlist
        ? flow.submitWaitlist(waitlistUrl(), payload)
        : fetch(waitlistUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
            mode: 'cors',
          }).then(function (res) {
            if (!res.ok) throw new Error('Request failed');
          });
      submit
        .then(function () {
          showWlMessage('', "You're on the waitlist!");
          if (els.wlName) els.wlName.value = '';
          if (els.wlEmail) els.wlEmail.value = '';
          if (els.wlNotes) els.wlNotes.value = '';
        })
        .catch(function (err) {
          showWlMessage(
            (err && err.message ? String(err.message) : 'Something went wrong.').slice(0, 200),
            ''
          );
        })
        .then(function () {
          wlSubmitting = false;
          updateCta();
        });
    }

    function updateCta() {
      var copy = session.copy;
      renderBag();
      if (session.step === 2) {
        syncCta(wlSubmitting ? 'Joining…' : waitlistLabel(), wlSubmitting);
        return;
      }
      if (!session.slots.length || !hasBookable()) {
        syncCta(waitlistLabel(), false);
        return;
      }
      if (session.selectedSlot && !slotBookable(session.selectedSlot)) {
        syncCta(waitlistLabel(), false);
        return;
      }
      if (session.selectedDate && !dateHasBookable(session.selectedDate)) {
        syncCta(waitlistLabel(), false);
        return;
      }
      if (session.step === 0 && !isCompact()) {
        syncCta(copy.next || 'Continue', false);
        return;
      }
      syncCta(adding ? 'Adding…' : 'Add to cart', adding);
    }

    function styleById(id) {
      var i;
      for (i = 0; i < session.styles.length; i++) {
        if (String(session.styles[i].id) === String(id)) return session.styles[i];
      }
      return null;
    }

    function changeQty(id, delta) {
      var style = styleById(id);
      if (delta > 0 && style && !style.available) return;
      var next = (session.qty[id] || 0) + delta;
      if (next < 0) next = 0;
      var used = totalQty() - (session.qty[id] || 0);
      if (used + next > maxBookable()) next = Math.max(0, maxBookable() - used);
      if (next <= 0) delete session.qty[id];
      else session.qty[id] = next;
      if (!syncStyleRows()) renderStyles();
      if (els.zoom && !els.zoom.hidden) renderZoom();
      if (totalQty() > 0) {
        showWhenError('');
        showError('');
        if (els.stylesList) els.stylesList.classList.remove('is-invalid');
      }
      updateCta();
    }

    function selectDate(dateKey) {
      session.selectedDate = dateKey;
      var keep =
        session.selectedSlot &&
        slotDateKey(session.selectedSlot) === dateKey &&
        slotBookable(session.selectedSlot);
      if (!keep) session.selectedSlot = null;
      if (useCalendar()) renderCalendar();
      else renderDateList();
      renderTimes();
      showWhenError('');
      setMenu(els.dateDd, els.dateMenu, els.dateTrigger, calendarOpen());
      updateCta();
    }

    function openZoom(id) {
      if (!els.zoom || !session.styles.length) return;
      var idx = 0;
      var i;
      for (i = 0; i < session.styles.length; i++) {
        if (String(session.styles[i].id) === String(id)) {
          idx = i;
          break;
        }
      }
      zoomIndex = idx;
      overlay.classList.add('is-zoom');
      els.zoom.hidden = false;
      renderZoom();
    }

    function shiftZoom(dir) {
      if (!session.styles.length) return;
      zoomIndex = (zoomIndex + dir + session.styles.length) % session.styles.length;
      renderZoom();
    }

    function renderZoom() {
      var style = session.styles[zoomIndex];
      if (!style || !els.zoomImg) return;
      var src = zoomSrc(style.image);
      var fallback = String(src)
        .replace(/([?&])width=\d+/g, '$1')
        .replace(/\?&/, '?')
        .replace(/[?&]$/, '');
      els.zoomImg.onerror = function () {
        if (els.zoomImg.getAttribute('data-fallback') === '1') return;
        els.zoomImg.setAttribute('data-fallback', '1');
        els.zoomImg.src = fallback || src;
      };
      els.zoomImg.removeAttribute('data-fallback');
      els.zoomImg.alt = style.title || 'Workshop style';
      els.zoomImg.src = src;
      if (els.zoomTitle) els.zoomTitle.textContent = style.title || 'Style';
      if (els.zoomMeta) els.zoomMeta.innerHTML = priceHtml(style, 'one seat');
      var q = session.qty[style.id] || 0;
      var max = maxBookable();
      var used = totalQty();
      if (els.zoomN) els.zoomN.textContent = q;
      if (els.zoomMinus) {
        els.zoomMinus.setAttribute('data-id', style.id);
        els.zoomMinus.disabled = q <= 0;
      }
      if (els.zoomPlus) {
        els.zoomPlus.setAttribute('data-id', style.id);
        els.zoomPlus.disabled = used >= max || !style.available;
      }
      var many = session.styles.length > 1;
      if (els.zoomPrev) els.zoomPrev.hidden = !many;
      if (els.zoomNext) els.zoomNext.hidden = !many;
    }

    function closeZoom() {
      if (!els.zoom) return;
      overlay.classList.remove('is-zoom');
      els.zoom.hidden = true;
      if (els.zoomImg) {
        els.zoomImg.onerror = null;
        els.zoomImg.removeAttribute('src');
        els.zoomImg.removeAttribute('data-fallback');
      }
    }

    function selectTime(gid) {
      var dateKey = session.selectedDate || timesDateKey();
      var found = session.slots.filter(function (slot) {
        return (
          slotDateKey(slot) === dateKey &&
          String(slot.gid || slotTimeLabel(slot)) === String(gid)
        );
      })[0];
      if (!found) return;
      if (!slotBookable(found)) {
        session.selectedDate = slotDateKey(found) || session.selectedDate;
        session.selectedSlot = found;
        showWaitlist('sold_out', hasBookable());
        return;
      }
      if (!session.selectedDate) {
        showWhenError('Please pick a date.');
        shakeMissing();
        return;
      }
      session.selectedSlot = found;
      renderTimes();
      showWhenError('');
      updateCta();
      refreshCartSeats().catch(function () {});
    }

    function goNext() {
      if (adding || advancing || wlSubmitting) return;
      if (session.step === 2) {
        submitWaitlist();
        return;
      }
      if (
        !session.slots.length ||
        !hasBookable() ||
        (session.selectedSlot && !slotBookable(session.selectedSlot)) ||
        (session.selectedDate && !dateHasBookable(session.selectedDate))
      ) {
        showWaitlist(
          session.slots.length ? 'sold_out' : 'no_events',
          !!(session.slots.length && hasBookable())
        );
        return;
      }
      if (session.step === 0) {
        var warn = whenWarning();
        if (warn) {
          showWhenError(warn);
          shakeMissing();
          var jump = els.whenError;
          if (isCompact() && session.selectedSlot && totalQty() < 1 && els.inlineStyles) {
            jump = els.inlineStyles;
          }
          if (jump && jump.scrollIntoView) jump.scrollIntoView({ block: 'nearest', behavior: 'auto' });
          return;
        }
        if (isCompact()) {
          addToCart();
          return;
        }
        advancing = true;
        refreshCartSeats().catch(function () {});
        setStep(1);
        advancing = false;
        return;
      }
      if (totalQty() < 1) {
        showError('Please choose at least one ' + (session.copy.unit || 'style') + '.');
        shakeMissing();
        if (els.stylesList) {
          els.stylesList.classList.add('is-invalid');
          if (els.stylesList.scrollIntoView) {
            els.stylesList.scrollIntoView({ block: 'nearest', behavior: 'auto' });
          }
        }
        return;
      }
      addToCart();
    }

    function addToCart() {
      if (adding || !session.selectedSlot || totalQty() < 1) return;
      adding = true;
      updateCta();
      syncCta('Adding…', true);
      var qty = totalQty();
      ensureFreshSlot(session.selectedSlot)
        .then(function (fresh) {
          if (!fresh || !slotBookable(fresh)) {
            throw new Error('This session is no longer available. Please choose another time.');
          }
          var max = maxBookable();
          if (qty > max || max <= 0) {
            throw new Error(
              max <= 0 ? 'This session is sold out.' : 'Only ' + max + ' seat(s) remain for this session.'
            );
          }
          return refreshCartSeats().then(function () {
            return validateCapacity(fresh, qty);
          });
        })
        .then(function (validation) {
          if (!validation) return;
          if (validation.blocked) throw new Error(validation.message || 'Unable to add to cart.');
          var slot = validation.slot || session.selectedSlot;
          var props = buildEventProperties(slot);
          var items = [];
          session.styles.forEach(function (style) {
            var q = session.qty[style.id] || 0;
            if (!q) return;
            items.push({ id: style.id, quantity: q, properties: Object.assign({}, props) });
          });
          if (!items.length) throw new Error('Select at least one seat.');
          var payload = { items: items };
          var sections = F().getCartSections ? F().getCartSections() : [];
          if (sections.length) {
            payload.sections = sections.join(',');
            payload.sections_url = (global.location && global.location.pathname) || '/';
          }
          return fetch(shopRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          }).then(function (res) {
            return res.json().then(function (body) {
              if (!res.ok || body.status === 422) {
                throw new Error(body.description || 'Unable to add to cart.');
              }
              return body;
            });
          });
        })
        .then(function (body) {
          if (!body) return;
          close();
          if (F().dispatchCartUi) F().dispatchCartUi(body);
        })
        .catch(function (err) {
          var msg = err && err.message ? err.message : 'Unable to add to cart.';
          showError(msg);
          if (/sold out|no longer available/i.test(msg)) session.wlContext = 'sold_out';
        })
        .finally(function () {
          adding = false;
          updateCta();
        });
    }

    function onKey(e) {
      if (els.zoom && !els.zoom.hidden) {
        if (e.key === 'Escape') {
          closeZoom();
          return;
        }
        if (e.key === 'ArrowLeft') {
          shiftZoom(-1);
          return;
        }
        if (e.key === 'ArrowRight') {
          shiftZoom(1);
          return;
        }
        return;
      }
      if (e.key === 'Escape') close();
    }

    function resetChrome() {
      adding = false;
      advancing = false;
      overlay.classList.remove('is-when', 'is-compact', 'is-zoom', 'is-ready', 'is-soldout', 'is-waitlist');
      wlSubmitting = false;
      if (els.steps) els.steps.hidden = false;
      showWlMessage('', '');
      if (els.wlName) els.wlName.value = '';
      if (els.wlEmail) els.wlEmail.value = '';
      if (els.wlNotes) els.wlNotes.value = '';
      overlay.removeAttribute('data-date-mode');
      if (els.inlineStyles) {
        els.inlineStyles.hidden = true;
        els.inlineStyles.classList.remove('is-invalid');
      }
      if (els.brand) els.brand.textContent = 'A lamp that lights your home';
      if (els.crumbWhen) els.crumbWhen.textContent = 'Date';
      if (els.crumbStyle) {
        els.crumbStyle.hidden = false;
        els.crumbStyle.textContent = 'Style';
      }
      els.crumbs.forEach(function (crumb) {
        crumb.hidden = false;
        crumb.classList.remove('is-on', 'is-done');
      });
      if (els.cta) {
        els.cta.textContent = 'Continue';
        els.cta.disabled = true;
      }
      if (els.ctaWhen) {
        els.ctaWhen.textContent = 'Continue';
        els.ctaWhen.disabled = false;
      }
      if (els.bag) els.bag.hidden = true;
      if (els.bagWhen) {
        els.bagWhen.hidden = true;
        els.bagWhen.textContent = '';
      }
    }

    function open(product, slots, opts) {
      opts = opts || {};
      resetChrome();
      paint = emptyPaint();
      session = emptySession();
      if (els.stylesInline) els.stylesInline.innerHTML = '';
      if (els.stylesList) els.stylesList.innerHTML = '';
      session.product = product || {};
      session.slots = (slots || []).slice();
      session.slotsSig = slotsSignature(session.slots);
      session.pendingSlots = !!opts.pendingSlots && !session.slots.length;
      session.copy = styleCopy((product && product.workshopType) || 'mosaic');
      if (session.product.handle && productData[session.product.handle]) {
        applyShopify(productData[session.product.handle]);
      }
      session.selectedSlot = null;
      session.preferredDate = String(opts.date || '').slice(0, 10);
      session.selectedDate = session.slots.length
        ? pickPreferredDate(session.preferredDate)
        : '';
      var d = parseDateKey(session.selectedDate || session.preferredDate || firstDateKey());
      if (d) session.viewMonth = new Date(d.getFullYear(), d.getMonth(), 1);
      setOverlayAttrs();
      lastFocus = document.activeElement;
      overlay.hidden = false;
      document.documentElement.classList.add('swb-lock');
      if (session.pendingSlots) {
        setStep(0);
      } else if (!session.slots.length || !hasBookable()) {
        session.wlContext = session.slots.length ? 'sold_out' : 'no_events';
        session.wlReturn = false;
        setStep(2);
      } else {
        setStep(0);
      }
      if (session.product.handle) {
        fetchProductJs(session.product.handle)
          .then(function (shopify) {
            session.shopify = shopify;
            session.styles = stylesFromProduct(shopify);
            if (isCompact() && session.step === 0) renderStyles();
            updateCta();
          })
          .catch(function () {});
      }
      if (els.sheet && els.sheet.focus) els.sheet.focus({ preventScroll: true });
      bindBookLive();
    }

    function tickOpenLive() {
      if (overlay.hidden || !session.slots.length) return;
      var API = global.WorkshopCityEvents || {};
      if (!API.fetchLiveState) return;
      var gids = [];
      session.slots.forEach(function (slot) {
        if (slot && slot.gid) gids.push(slot.gid);
      });
      if (!gids.length) return;
      API.fetchLiveState(gids, { url: resolveLiveUrl(), root: collectionRoot })
        .then(function (r) {
          var merged =
            API.mergeSlotsWithLive && r
              ? API.mergeSlotsWithLive(session.slots, r.states || {}, r.as_of)
              : session.slots;
          applySlots(merged);
        })
        .catch(function () {});
    }

    function bindBookLive() {
      if (collectionRoot.__swbLiveUnsub) return;
      var Stream = global.WorkshopLiveStream;
      if (!Stream || typeof Stream.subscribe !== 'function') return;
      collectionRoot.__swbLiveUnsub = Stream.subscribe(function (evt) {
        if (!evt || overlay.hidden) return;
        if (evt.type === 'live') {
          tickOpenLive();
          return;
        }
        if (
          evt.type === 'catalog' ||
          evt.scope === 'catalog' ||
          (evt.payload && evt.payload.scope === 'catalog')
        ) {
          tickOpenLive();
        }
      });
    }

    function applySlots(slots) {
      if (!session.product) return;
      session.pendingSlots = false;
      var next = (slots || []).slice();
      var sig = slotsSignature(next);
      if (sig === session.slotsSig && session.slots.length) return;
      session.slotsSig = sig;
      session.slots = next;
      if (session.selectedSlot) {
        var gid = String(session.selectedSlot.gid || '');
        var fresh = session.slots.filter(function (slot) {
          return String(slot.gid || '') === gid;
        })[0];
        session.selectedSlot = fresh && slotBookable(fresh) ? fresh : null;
      }
      if (!session.selectedDate || !daysMap()[session.selectedDate]) {
        session.selectedDate = pickPreferredDate(session.preferredDate);
      }
      var prefDay = parseDateKey(session.selectedDate || session.preferredDate);
      if (prefDay) session.viewMonth = new Date(prefDay.getFullYear(), prefDay.getMonth(), 1);
      paint = emptyPaint();
      if (overlay.hidden) return;
      if (!session.slots.length || !hasBookable()) {
        if (session.step !== 2) {
          session.wlContext = session.slots.length ? 'sold_out' : 'no_events';
          session.wlReturn = false;
        }
        setStep(2);
        return;
      }
      if (session.step === 2 && !session.wlReturn) {
        session.wlContext = '';
        setStep(0);
        return;
      }
      renderWhen();
      if (session.step === 1) renderStyles();
      if (session.step === 2) renderWaitlist();
      updateCta();
    }

    function close() {
      overlay.hidden = true;
      document.documentElement.classList.remove('swb-lock');
      if (collectionRoot && collectionRoot.__swcLivePoll && collectionRoot.__swcLivePoll.syncInterval) {
        collectionRoot.__swcLivePoll.syncInterval();
      }
      session = emptySession();
      paint = emptyPaint();
      resetChrome();
      closeMenus();
      closeZoom();
      showError('');
      showWhenError('');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onClick(e) {
      if (e.target.closest('[data-swb-zoom-close]') || e.target === els.zoom) {
        closeZoom();
        return;
      }
      if (e.target.closest('[data-swb-zoom-prev]')) {
        shiftZoom(-1);
        return;
      }
      if (e.target.closest('[data-swb-zoom-next]')) {
        shiftZoom(1);
        return;
      }
      var zoomBtn = e.target.closest('[data-swb-zoom]');
      if (zoomBtn && !e.target.closest('[data-swb-zoom-layer]')) {
        openZoom(zoomBtn.getAttribute('data-swb-zoom'));
        return;
      }
      if (e.target.closest('[data-swb-dismiss]')) {
        close();
        return;
      }
      if (e.target.closest('[data-swb-back]')) {
        if (session.step === 2 && session.wlReturn) {
          session.wlContext = '';
          setStep(0);
          return;
        }
        if (session.step > 0) setStep(session.step - 1);
        return;
      }
      if (e.target.closest('[data-swb-date-trigger]')) {
        if (calendarOpen()) {
          setMenu(els.dateDd, els.dateMenu, els.dateTrigger, true);
          return;
        }
        var dateOpen = !(els.dateDd && els.dateDd.classList.contains('is-open'));
        setMenu(els.dateDd, els.dateMenu, els.dateTrigger, dateOpen);
        return;
      }
      if (e.target.closest('[data-swb-cal-prev]')) {
        shiftMonth(-1);
        return;
      }
      if (e.target.closest('[data-swb-cal-next]')) {
        shiftMonth(1);
        return;
      }
      var day = e.target.closest('[data-swb-day]');
      if (day && !day.disabled) {
        selectDate(day.getAttribute('data-swb-day'));
        return;
      }
      var time = e.target.closest('[data-swb-time]');
      if (time && !time.disabled) {
        selectTime(time.getAttribute('data-swb-time'));
        return;
      }
      var qtyBtn = e.target.closest('[data-swb-qty]');
      if (qtyBtn) {
        if (!qtyBtn.disabled) {
          changeQty(qtyBtn.getAttribute('data-id'), Number(qtyBtn.getAttribute('data-swb-qty')) || 0);
        }
        return;
      }
      if (e.target.closest('.swb__stepper, .swb__zoom-stepper')) return;
      var styleCard = e.target.closest('[data-swb-style]');
      if (styleCard && (session.step === 1 || (isCompact() && session.step === 0))) {
        changeQty(styleCard.getAttribute('data-swb-style'), 1);
        return;
      }
      if (e.target.closest('[data-swb-cta], [data-swb-cta-when]')) {
        goNext();
      }
    }

    function bindAxisSwipe(el, handlers) {
      if (!el || el.__swbSwipe) return;
      el.__swbSwipe = true;
      var sx = 0;
      var sy = 0;
      var active = false;
      el.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || e.touches.length !== 1) return;
          active = true;
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
        },
        { passive: true }
      );
      el.addEventListener(
        'touchend',
        function (e) {
          if (!active) return;
          active = false;
          var t = e.changedTouches && e.changedTouches[0];
          if (!t) return;
          var dx = t.clientX - sx;
          var dy = t.clientY - sy;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.15) return;
          if (dx < 0 && handlers.left) handlers.left();
          if (dx > 0 && handlers.right) handlers.right();
        },
        { passive: true }
      );
    }

    function bindSheetDismiss() {
      if (!els.sheet || els.sheet.__swbDismiss) return;
      els.sheet.__swbDismiss = true;
      var startY = 0;
      var startX = 0;
      var fromTop = false;
      els.sheet.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || e.touches.length !== 1) return;
          if (overlay.classList.contains('is-zoom')) return;
          var y = e.touches[0].clientY;
          var top = els.sheet.getBoundingClientRect().top;
          fromTop = y - top < 56;
          startY = y;
          startX = e.touches[0].clientX;
        },
        { passive: true }
      );
      els.sheet.addEventListener(
        'touchend',
        function (e) {
          if (!fromTop) return;
          fromTop = false;
          var t = e.changedTouches && e.changedTouches[0];
          if (!t) return;
          var dy = t.clientY - startY;
          var dx = t.clientX - startX;
          if (dy > 56 && dy > Math.abs(dx) * 1.2) close();
        },
        { passive: true }
      );
    }

    if (!bound) {
      bound = true;
      overlay.addEventListener('click', onClick);
      document.addEventListener('keydown', function (e) {
        if (!overlay.hidden) onKey(e);
      });
      bindAxisSwipe(els.dateMenu, {
        left: function () {
          if (calendarOpen()) shiftMonth(1);
        },
        right: function () {
          if (calendarOpen()) shiftMonth(-1);
        },
      });
      bindAxisSwipe(els.zoom, {
        left: function () {
          if (els.zoom && !els.zoom.hidden) shiftZoom(1);
        },
        right: function () {
          if (els.zoom && !els.zoom.hidden) shiftZoom(-1);
        },
      });
      bindSheetDismiss();
    }

    return {
      open: open,
      close: close,
      applySlots: applySlots,
      isOpen: function () {
        return !overlay.hidden;
      },
      currentHandle: function () {
        return (session.product && session.product.handle) || '';
      },
      currentSlots: function () {
        return (session.slots || []).slice();
      },
    };
  }

  function bind(collectionRoot) {
    if (!collectionRoot) return null;
    if (collectionRoot.__swb) return collectionRoot.__swb;
    collectionRoot.__swb = createController(collectionRoot);
    return collectionRoot.__swb;
  }

  global.StateWorkshopBook = {
    bind: bind,
    prefetch: function (handle) {
      if (handle) fetchProductJs(handle).catch(function () {});
    },
  };
})(typeof window !== 'undefined' ? window : this);
